import * as React from 'react';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { paymentMethod, ticketState } from '@modules/tickets/_ticketsEnums';

import {
  InputField,
  Input,
  RemoteAutoComplete,
  Date,
  DateField,
  RemoteAutoCompleteField,
  AutoCompleteField,
  AutoComplete
} from '@components/form';

const View: React.SFC<any> = ({ delict }) => {
  const { fine, resolution } = delict;
  return (
    <div>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        {resolution &&
          resolution === 'BNP' && (
            <Col>
              <Col md={12} className="with-right-divider">
                <Row>
                  <Col md={12}>
                    <h4>BNP</h4>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={6}>
                        <RemoteAutoCompleteField
                          component={RemoteAutoComplete}
                          name="fine.employee"
                          label="Zaměstnanec"
                          url={`/metropolis/api/hr/employees`}
                          fullWidth={true}
                          labelFunction={o => get(o, 'fullName', '')}
                          valueFunction={o => o}
                          disabled={true}
                        />
                      </Col>
                      {[{ name: 'fine.fullNumber', label: 'Doklad' }, { name: 'fine.value', label: 'Suma' }].map(
                        field => (
                          <Col md={6} key={field.name}>
                            <InputField component={Input} name={field.name} label={field.label} disabled={true} />
                          </Col>
                        )
                      )}
                      <Col md={6}>
                        <AutoCompleteField
                          component={AutoComplete}
                          name="fine.state"
                          label="Stav dokladu"
                          fullWidth={true}
                          items={ticketState}
                          labelFunction={o => get(o, 'label')}
                          valueFunction={o => get(o, 'id')}
                          disabled={true}
                        />
                      </Col>
                      {[{ name: 'fine.useDate', label: 'Datum užití' }].map(field => (
                        <Col md={6} key={field.name}>
                          <DateField
                            component={Date}
                            name={field.name}
                            label={field.label}
                            dateOnly={false}
                            disabled={true}
                          />
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Col>
              {fine.check ? (
                <Col>
                  <Col md={12} className="with-right-divider">
                    <Row>
                      <Col md={12}>
                        <h4>Platba</h4>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <RemoteAutoCompleteField
                              component={RemoteAutoComplete}
                              name="fine.check.employee"
                              label="Zaměstnanec"
                              url={`/metropolis/api/hr/employees`}
                              fullWidth={true}
                              labelFunction={o => get(o, 'fullName', '')}
                              valueFunction={o => o}
                              disabled={true}
                            />
                          </Col>
                          {[{ name: 'fine.check.fullNumber', label: 'Doklad' }].map(field => (
                            <Col md={6} key={field.name}>
                              <InputField component={Input} name={field.name} label={field.label} disabled={true} />
                            </Col>
                          ))}
                          <Col md={6}>
                            <AutoCompleteField
                              component={AutoComplete}
                              name="fine.check.paymentMethod"
                              label="Platební metoda"
                              fullWidth={true}
                              items={paymentMethod}
                              labelFunction={o => get(o, 'label')}
                              valueFunction={o => get(o, 'id')}
                              disabled={true}
                            />
                          </Col>
                          <Col md={6}>
                            <AutoCompleteField
                              component={AutoComplete}
                              name="fine.check.state"
                              label="Stav dokladu"
                              fullWidth={true}
                              items={ticketState}
                              labelFunction={o => get(o, 'label')}
                              valueFunction={o => get(o, 'id')}
                              disabled={true}
                            />
                          </Col>
                          {[{ name: 'fine.check.collectDate', label: 'Datum zaplacení' }].map(field => (
                            <Col md={6} key={field.name}>
                              <DateField
                                component={Date}
                                name={field.name}
                                label={field.label}
                                dateOnly={false}
                                disabled={true}
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Col>
              ) : null}
            </Col>
          )}
        {resolution &&
          resolution === 'BNZ' && (
            <Col>
              <Col md={12} className="with-right-divider">
                <Row>
                  <Col md={12}>
                    <h4>Platba</h4>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Row>
                      <Col md={6}>
                        <RemoteAutoCompleteField
                          component={RemoteAutoComplete}
                          name="fine.employee"
                          label="Zaměstnanec"
                          url={`/metropolis/api/hr/employees`}
                          fullWidth={true}
                          labelFunction={o => get(o, 'fullName', '')}
                          valueFunction={o => o}
                          disabled={true}
                        />
                      </Col>
                      {[{ name: 'fine.fullNumber', label: 'Doklad' }, { name: 'fine.value', label: 'Suma' }].map(
                        field => (
                          <Col md={6} key={field.name}>
                            <InputField component={Input} name={field.name} label={field.label} disabled={true} />
                          </Col>
                        )
                      )}
                      <Col md={6}>
                        <AutoCompleteField
                          component={AutoComplete}
                          name="fine.state"
                          label="Stav dokladu"
                          fullWidth={true}
                          items={ticketState}
                          labelFunction={o => get(o, 'label')}
                          valueFunction={o => get(o, 'id')}
                          disabled={true}
                        />
                      </Col>
                      {[{ name: 'fine.useDate', label: 'Datum užití' }].map(field => (
                        <Col md={6} key={field.name}>
                          <DateField
                            component={Date}
                            name={field.name}
                            label={field.label}
                            dateOnly={false}
                            disabled={true}
                          />
                        </Col>
                      ))}
                      <Col md={6}>
                        <AutoCompleteField
                          component={AutoComplete}
                          name="fine.paymentMethod"
                          label="Platební metoda"
                          fullWidth={true}
                          items={paymentMethod}
                          labelFunction={o => get(o, 'label')}
                          valueFunction={o => get(o, 'id')}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Col>
          )}
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />
    </div>
  );
};

export const DelictsFormPayment = View;



// WEBPACK FOOTER //
// ./src/modules/delicts/DelictsFormPayment.tsx